import { render, staticRenderFns } from "./AdminChangelogInnerTableModal.vue?vue&type=template&id=234c30ca&"
import script from "./AdminChangelogInnerTableModal.vue?vue&type=script&lang=ts&"
export * from "./AdminChangelogInnerTableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports